import { useGeInventoryOptions } from '../../../hooks/reactQuerys/InventoryOptionQueries';
import { useGePropertyTypes } from '../../../hooks/reactQuerys/PropertyTypeQueries';
import { useGePurchaseContractRelationType } from '../../../hooks/reactQuerys/PurchaseContractQueries';
import { useGeRealEstateUseTypes } from '../../../hooks/reactQuerys/RealEstateQueries';

export const usePurchaseContractMeta = () => {
  const { propertyTypes, isLoadingPropertyTypes } = useGePropertyTypes();
  const { inventoryOptions, isLoadingInventoryOptions } =
    useGeInventoryOptions();
  const {
    purchaseContractRelationTypes,
    isLoadingPurchaseContractRelationTypes,
  } = useGePurchaseContractRelationType();
  const { realEstateUseTypes, isLoadingRealEstateUseTypes } =
    useGeRealEstateUseTypes();

  return {
    isNoData:
      propertyTypes === undefined ||
      inventoryOptions === undefined ||
      realEstateUseTypes === undefined ||
      purchaseContractRelationTypes === undefined,
    isLoading:
      isLoadingPropertyTypes ||
      isLoadingInventoryOptions ||
      isLoadingPurchaseContractRelationTypes ||
      isLoadingRealEstateUseTypes,
    propertyTypes,
    inventoryOptions,
    realEstateUseTypes,
    purchaseContractRelationTypes,
  };
};
